<div class="page-container">
  <div
    class="root-container"
    fxLayout="row"
    fxLayoutAlign="center center"
    *ngIf="{
      loginInfo: (loginInfo$ | async),
      isLoadingProfiles: (isLoadingProfiles$ | async),
      profiles: (profiles$ | async),
    } as observables"
  >
    <div class="content-container">
      <button
        *ngIf="!showLoader"
        mat-icon-button
        id="backButton"
        class="upperButton"
        type="button"
        [disabled]="observables.isLoadingProfiles || isApplyingProfile"
        (click)="cancel()"
        aria-label="Zurück"
        matTooltip="Zurück"
      >
        <mat-icon [svgIcon]="res.svgName('ProfileSelectionBack-Image')" class="upperButtonIcon"></mat-icon>
      </button>
      <div fxLayout="row" fxLayoutAlign="center center">
        <div *ngIf="observables.loginInfo && !observables.loginInfo.isAnonymous" class="titleText">
          {{ observables.loginInfo.displayName }}
        </div>
      </div>

      <div *ngIf="!showLoader" class="introText">Profil auswählen:</div>
      <div *ngIf="!showLoader" class="search-container">
        <abc-text-box
          class="search-input"
          valueChangeEvent="input"
          [width]="'50%'"
          [value]="searchTerm"
          placeholder="Profil suchen..."
          (valueChange)="searchProfiles($event)"
        ></abc-text-box>
      </div>
      <div class="introText-" *ngIf="showLoader" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <span>Profil ausgewählt:</span>
        <div>{{ selectedProfilesName }}</div>
        <ubt-loader></ubt-loader>
      </div>

      <div class="profiles-container">
        <ng-container
          *ngIf="
            !observables.isLoadingProfiles && !isApplyingProfile && !ErrorMessage && observables.profiles;
            else loadingDataTemplate
          "
        >
          <ng-container *ngIf="getFilteredProfiles(observables.profiles).length; else noResultsTemplate">
            <div
              class="profile-items-container"
              fxLayout="row"
              fxLayoutWrap="wrap"
              fxLayoutAlign="center start"
              fxLayoutGap="20px"
            >
              <div
                *ngFor="let profile of getFilteredProfiles(observables.profiles)"
                (click)="selectProfileAndApply(profile)"
                class="profile-card"
              >
                <mat-icon
                  *ngIf="!showLoader"
                  [svgIcon]="res.svgName('ProfileSelectionUser-Image')"
                  class="upperUserImg"
                ></mat-icon>
                <label *ngIf="!showLoader" class="profileDesignation">{{ profile.displayText }}</label>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <abcLoader *ngIf="showLoader" [class]="'login-loader'" [show]="showLoader" id="login-loader"></abcLoader>
      </div>

      <ng-template #loadingDataTemplate>
        <ng-container *ngIf="!isApplyingProfile && !ErrorMessage">
          <ng-container
            *ngTemplateOutlet="
              progressTemplate;
              context: getProgressTemplateContext(
                'Bitte warte, während die verfügbaren Benutzerprofile geladen werden...'
              )
            "
          >
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #applyingProfileTemplate>
        <ng-container *ngIf="!ErrorMessage">
          <ng-container
            *ngTemplateOutlet="
              progressTemplate;
              context: getProgressTemplateContext('Benutzerprofil wird übernommen...')
            "
          >
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #progressTemplate let-message="message">
        <div class="loaderClass dark {{ errorClass ? ' ' + errorClass : '' }}">
          <div class="msgStyle dark">{{ message }}</div>
          <abcLoader
            [id]="'loaderProfiles'"
            [class]="'loader'"
            [show]="true"
            [percentageValue]="false"
            [mode]="'indeterminate'"
          >
          </abcLoader>
        </div>
      </ng-template>

      <ng-template #noProfilesTemplate>
        <div class="errorStyleClass {{ errorClass ? ' ' + errorClass : '' }}">
          <div class="waring">
            <mat-icon class="iconError" svgIcon="auth_error"></mat-icon>
          </div>
          <div class="descriptionError">
            <span>Für den aktuellen Benutzer sind keine Benutzerprofile vorhanden.</span>
            <span>Wende Dich an Deinen Systemadministrator!</span>
          </div>
        </div>
      </ng-template>

      <ng-template #noResultsTemplate>
        <div class="errorStyleClass {{ errorClass ? ' ' + errorClass : '' }}">
          <div class="waring">
            <mat-icon class="iconError" svgIcon="auth_error"></mat-icon>
          </div>
          <div class="descriptionError">
            <span>Es wurde kein Profil mit dem Namen "{{ searchTerm }}" gefunden.</span>
            <span>Bitte überprüfe Deine Eingabe</span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
